export default "__VITE_ASSET__mopTefei__";